import { render, staticRenderFns } from "./cultrue.vue?vue&type=template&id=a7bc33b0&scoped=true&"
var script = {}
import style0 from "./cultrue.vue?vue&type=style&index=0&id=a7bc33b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7bc33b0",
  null
  
)

export default component.exports